import type { CreateLikeFolderParams, CreateLikeFolderResponse } from './types';
import { defaultHttpClient } from 'shared/src/api/httpClient';

/**
 * 20개씩 pagination
 */
export const postLikeFolder = async (params: CreateLikeFolderParams) => {
  return defaultHttpClient.request<CreateLikeFolderResponse>({
    method: 'POST',
    url: '/api/v2/members/me/liked_folders/',
    data: params,
  });
};
